module.exports = __webpack_public_path__ + "static/media/bg_notice_popup_default.d2cac060.webp";